// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a42574db","697":"ba63e88a"}[chunkId] + ".chunk.js";
};